import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { SentmessageModel } from './sentmessage.model';

export class LogentryModel extends BaseModel implements Deserializable {

  // columns
  timestamp: string;
  change?: string;
  value?: any;
  user?: string;
  message?: SentmessageModel;

}
